module.exports = __webpack_public_path__ + "img/location.370e6e85.svg";